/**
 * Mock categories — built from the static CATEGORIES list in src/content/categories.ts
 * with deterministic UUIDs so they can be cross-referenced from providers/requests.
 */

import { CATEGORIES } from '@/content/categories'
import type { Tables, Json } from '@/lib/db.types'
import { categoryId } from './ids'

type Category = Tables<'categories'>

const NOW = new Date('2026-05-01T08:00:00.000Z').toISOString()

export const MOCK_CATEGORIES: Category[] = CATEGORIES.map((c) => ({
  id: categoryId(c.slug),
  slug: c.slug,
  name_sv: c.name_sv,
  name_en: c.name_en,
  description_sv: `${c.name_sv} — hitta erfarna leverantörer i hela Sverige.`,
  parent_id: c.parent_slug ? categoryId(c.parent_slug) : null,
  icon: c.icon,
  sort_order: c.sort_order,
  rut_eligible: c.rut_eligible,
  rot_eligible: c.rot_eligible,
  license_required: c.license_required,
  quote_fields: c.quote_fields as unknown as Json,
  is_active: true,
  created_at: NOW,
  updated_at: NOW,
}))

export function findCategoryBySlug(slug: string): Category | undefined {
  return MOCK_CATEGORIES.find((c) => c.slug === slug)
}

export function findCategoryById(id: string): Category | undefined {
  return MOCK_CATEGORIES.find((c) => c.id === id)
}
